'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'comment';
var width = 512;
var height = 512;
var aliases = [128489,61669];
var unicode = 'f075';
var svgPathData = 'M107 376.7c-6.9 17-14.5 35.5-22.6 55.6 41-14.1 64.2-22.1 69.8-24l16.8 7c25.9 10.7 54.6 16.8 85.1 16.8 117.8 0 208-88.8 208-192S373.8 48 256 48 48 136.8 48 240c0 42.7 15.1 82.4 41.2 114.6l17.8 22zM60.3 491.3L0 512C15.4 474.2 32.7 431.8 51.8 384.8 19.3 344.6 0 294.4 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240 397.4 480 256 480c-36.8 0-71.9-7.3-103.5-20.4L60.3 491.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComment = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;